export const getModuleMessages = async (locale: ApplicationLocale) => import(`@/modules/user/locales/${locale}.json`);

export default getModuleMessages;
